import type { HTMLAttributes } from "react";
import { formatMoney } from "@travelix/core";
import { cn } from "@/lib/utils";

interface MoneyTextProps extends Omit<HTMLAttributes<HTMLElement>, "children"> {
  amount: number;
  currency?: string;
  className?: string;
  as?: "span" | "p" | "div";
}

/**
 * Tabular-figures money display — Inter with `tnum` so digits line up in columns.
 * Sign is coded by color: negative = danger, positive/settled = success, zero = ink.
 *
 * Passes any extra HTML attributes (aria-live, aria-label, id…) to the
 * underlying element so callers can announce changes to totals.
 */
export function MoneyText({
  amount,
  currency = "EUR",
  className,
  as: Tag = "span",
  ...rest
}: MoneyTextProps) {
  return (
    <Tag className={cn("tabular font-sans", className)} {...rest}>
      {formatMoney(amount, currency)}
    </Tag>
  );
}
